import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Settings from '../views/Settings.vue'
import Dashboard from '../views/Dashboard.vue'
import Statistics from '../views/Statistics.vue'
import MyInfo from '../views/MyInfo.vue'
import ManageOwner from '../views/ManageOwner.vue'
import ManagePet from '../views/ManagePet.vue'
import Certificate from '../views/Certificate.vue'
import Examination from '../views/Examination.vue'
import Timeline from '../views/Timeline.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/MyInfo',
    name: 'MyInfo',
    component: MyInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/Timeline',
    name: 'Timeline',
    component: Timeline,
    meta: { requiresAuth: true }
  },
  {
    path: '/Certificate',
    name: 'Certificate',
    component: Certificate,
    meta: { requiresAuth: true }
  },
  {
    path: '/Examination',
    name: 'Examination',
    component: Examination,
    meta: { requiresAuth: true }
  },
  {
    path: '/ManageOwner',
    name: 'ManageOwner',
    component: ManageOwner,
    meta: { requiresAuth: true }
  },
  {
    path: '/ManagePet',
    name: 'ManagePet',
    component: ManagePet,
    meta: { requiresAuth: true }
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: Statistics,
    meta: { requiresAuth: true }
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.isAuthenticated) {
      next()
    } 
    else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})


export default router
